import { useCallback } from "react";
import { updateLanguage, type AppLanguage } from "../redux/companySlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

export function useGlobalLanguage() {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.company.language);
  const setLanguage = useCallback(
    (nextLanguage: AppLanguage) => {
      if (nextLanguage !== language)
        void dispatch(updateLanguage(nextLanguage));
    },
    [dispatch, language],
  );
  const toggleLanguage = useCallback(
    () => setLanguage(language === "ar" ? "en" : "ar"),
    [language, setLanguage],
  );

  return { language, setLanguage, toggleLanguage } as const;
}
